import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { CircleCheck, LogIn, Mail, Lock } from "lucide-react";
import { Link } from "react-router-dom";

export default function EmailRecovery() {
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [password, setPassword] = useState("");
  const [timer, setTimer] = useState(60);
  const [resending, setResending] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (step === 2 && timer > 0) {
      const interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [step, timer]);

  // CAMPO QUE SIMULA O ENVIO DO CÓDIGO PARA O EMAIL
  const sendCode = async (email) => {
    // console.log(`Código enviado para: ${email}`)
    await new Promise((res) => setTimeout(res, 1000));
  };

  const handleEmailSubmit = async (e) => {
    e.preventDefault();
    await sendCode(email);
    setTimer(40); // Timer de Reenviar código em segundos
    setStep(2);
  };

  // CAMPO PARA SIMULAÇAO DE SENHA
  const handleCodeSubmit = (e) => {
    e.preventDefault();
    if (code === "123456") {
      // SENHA DE TESTE

      setStep(3);
    } else {
      alert("Código inválido");
    }
  };

  const handleResend = async () => {
    setResending(true);
    await sendCode(email);
    setTimer(60);
    setResending(false);
  };

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();

    // Aqui você chamaria a API real para salvar a nova senha
    // console.log(`Senha redefinida: ${password}`)

    alert("Senha redefinida com sucesso! Redirecionando para o login...");

    // DEPOIS DE REDEFINIR A SENHA VOLTA PRO LOGIN
    setTimeout(() => {
      navigate("/login");
    }, 2000);
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-100 px-4 py-12">
      <Link
        to={"/login"}
        className="absolute top-4 left-4 bg-green-500 p-3 rounded-full text-white hover:bg-green-600 transition duration-300 transform hover:scale-105"
      >
        <LogIn className="-scale-x-100" size={20} />
      </Link>
      <div className="w-full max-w-md bg-white rounded-lg shadow-md overflow-hidden">
        {step === 1 && (
          <div>
            <div className="p-6 border-b border-gray-200">
              <h2 className="text-2xl font-bold text-center">
                Recuperar senha
              </h2>
              <p className="text-center text-gray-600 mt-1">
                Digite seu email para receber um código de recuperação
              </p>
            </div>
            <form onSubmit={handleEmailSubmit} className="p-6">
              <div className="mb-4 relative">
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Email
                </label>
                <div className="flex items-center">
                  <Mail className="absolute left-3 text-gray-500 w-5 h-5" />
                  <input
                    type="email"
                    name="email"
                    className="w-full pl-10 py-2 border rounded-md focus:outline-none focus:border-transparent focus:ring-2 focus:ring-green-500"
                    placeholder="Digite seu e-mail"
                    onChange={setEmail}
                    required
                  />
                </div>
              </div>

              <button
                type="submit"
                className="w-full mb-4 bg-green-500 text-white py-2 px-4 rounded-md hover:bg-green-600  focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2"
              >
                Enviar código
              </button>
            </form>
          </div>
        )}

        {step === 2 && (
          <div>
            <div className="p-6 border-b border-gray-200">
              <div className="flex items-center justify-center">
                <CircleCheck size={60} className="text-green-600"></CircleCheck>
              </div>
              <p className="text-center text-gray-600 mt-1">
                Um código foi enviado para <strong>{email}</strong>
              </p>
            </div>
            <form onSubmit={handleCodeSubmit} className="p-6">
              <div className="mb-4">
                <label
                  htmlFor="code"
                  className="block text-sm font-medium text-gray-700 mb-1"
                >
                  Código de verificação
                </label>
                <input
                  id="code"
                  type="text"
                  placeholder="Digite o código"
                  value={code}
                  onChange={(e) => setCode(e.target.value)}
                  required
                  className="w-full px-3 py-2 border rounded-md focus:outline-none focus:border-transparent focus:ring-2 focus:ring-green-500 "
                />
              </div>
              <button
                type="submit"
                className="w-full bg-green-600 text-white py-2 px-4 rounded-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2"
              >
                Verificar código
              </button>
              <div className="text-center text-sm text-gray-600 mt-4">
                {timer > 0 ? (
                  <>Você poderá reenviar em {timer}s</>
                ) : (
                  <button
                    type="button"
                    onClick={handleResend}
                    disabled={resending}
                    className="ttransition duration-200 hover:text-green-700 hover:underline"
                  >
                    Não recebi o e-mail
                  </button>
                )}
              </div>
            </form>
          </div>
        )}

        {step === 3 && (
          <div>
            <div className="p-6 border-b border-gray-200">
              <h2 className="text-2xl font-bold text-center">
                Redefinir senha
              </h2>
              <p className="text-center text-gray-600 mt-1">
                Digite sua nova senha para continuar
              </p>
            </div>
            <form onSubmit={handlePasswordSubmit} className="p-6">
              <div className="mb-4 relative">
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Nova Senha
                </label>
                <div className="flex items-center">
                  <Lock className="absolute left-3 text-gray-500 w-5 h-5" />
                  <input
                    type="password"
                    name="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="w-full pl-10 py-2 border rounded-md focus:outline-none focus:border-transparent focus:ring-2 focus:ring-green-500"
                    placeholder="Nova senha"
                    required
                  />
                </div>
              </div>

              <button
                type="submit"
                className="w-full mb-4 bg-green-500 text-white py-2 px-4 rounded-md hover:bg-green-600  focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2"
              >
                Redefinir senha
              </button>
            </form>
          </div>
        )}
      </div>
    </div>
  );
}
